module.exports = __webpack_public_path__ + "static/media/curr_pharmacy.b34eb2e7.png";